import { useState } from "react";
import { billingFetch } from "./billingApi";
import "./TopUpModal.css";

const TOPUP_OPTIONS = [
  { amount: 10, credits: 500 },
  { amount: 15, credits: 750 },
  { amount: 20, credits: 1000 },
  { amount: 25, credits: 1250 },
  { amount: 50, credits: 2500 },
  { amount: 100, credits: 5000 },
];

export default function TopUpModal({ isDarkMode, onClose }) {
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handlePurchase() {
    if (!selected) return;
    setLoading(true);
    setError(null);
    try {
      const data = await billingFetch("/stripe/add-credits", {
        method: "POST",
        body: JSON.stringify({ amount: selected }),
      });
      if (data.url) window.location.href = data.url;
    } catch (err) {
      const msg = err.message || "Failed to start checkout";
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="topup-overlay" onClick={onClose}>
      <div
        className={`topup-modal ${isDarkMode ? "dark" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="topup-close" onClick={onClose}>
          &times;
        </button>
        <div className="topup-icon">+</div>
        <h3>Add Credits</h3>
        <p>Select an amount to top up your credits (one-time purchase).</p>

        <div className="topup-grid">
          {TOPUP_OPTIONS.map((opt) => (
            <button
              key={opt.amount}
              className={`topup-option ${selected === opt.amount ? "selected" : ""}`}
              onClick={() => setSelected(opt.amount)}
              disabled={loading}
            >
              <span className="topup-amount">${opt.amount}</span>
              <span className="topup-credits">
                {opt.credits.toLocaleString()} credits
              </span>
            </button>
          ))}
        </div>

        <button
          className="topup-buy-btn"
          onClick={handlePurchase}
          disabled={!selected || loading}
        >
          {loading ? "Redirecting to Stripe..." : selected ? `Pay $${selected}` : "Select an amount"}
        </button>

        {error && <div className="topup-error">{error}</div>}
      </div>
    </div>
  );
}
